<div class="alert">
  <finxone-platform-alert-success-message
    *ngIf="alertType === 'success'"
    [msg]="alertMsg"
    [headerMsg]="headerMsg"
    [successalertMsgdiv]="successAlertMsgDiv"
    [successalertErroriconColor]="successAlertErrorIconColor"
    [successalertHeaderColor]="successAlertHeaderColor"
    [successcloseIconColor]="successCloseIconColor"
  ></finxone-platform-alert-success-message>

  <finxone-platform-alert-error-message
    [msg]="alertMsg"
    *ngIf="alertType === 'error'"
    [headerMsg]="headerMsg"
    [erroralertMsgdiv]="errorAlertMsgDiv"
    [erroralertErroriconColor]="errorAlertErrorIconColor"
    [erroralertHeaderColor]="errorAlertHeaderColor"
    [errorcloseIconColor]="errorCloseIconColor"
  ></finxone-platform-alert-error-message>

  <finxone-platform-alert-warning-message
    *ngIf="alertType === 'warning'"
    [msg]="alertMsg"
    [headerMsg]="headerMsg"
    [warningMsgdiv]="warningMsgDiv"
    [warningAlertErroriconColor]="warningAlertErrorIconColor"
    [warningAlertHeaderColor]="warningAlertHeaderColor"
    [warningCloseIconColor]="warningCloseIconColor"
  ></finxone-platform-alert-warning-message>
</div>
